module.exports = __webpack_public_path__ + "static/media/powerSupply1.1a57f5cd.svg";